export default {"src":"/_next/static/image/public/assets/feature-images/en/rewrite-formal.4fe9b03425db5586023cc48316bbffce.svg","height":371,"width":510};